
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { routes } from '../../MainPage';
const ToastMgs = props => {

    return (
        <div className={`Toast ${props.status !== "success" ? "Cancelled" : ''}`}
        onClick={props.toastProps.closeToast}>
            <div className="Toast-box">
                <div className="toast-icon">
                    {props.status == "success" ? <svg
                        className="checkmark"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 52 52"
                    >
                        <circle
                            className="checkmark__circle"
                            cx={26}
                            cy={26}
                            r={25}
                            fill="none"
                        />
                        <path
                            className="checkmark__check"
                            fill="none"
                            d="M14.1 27.2l7.1 7.2 16.7-16.8"
                        />
                    </svg> : <svg
                        className="checkmark"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 52 52"
                    >
                        <circle
                            className="checkmark__circle"
                            cx={26}
                            cy={26}
                            r={25}
                            fill="none"
                        />
                        <line
                            x1={1}
                            y1={50}
                            x2={50}
                            y2={1}
                            strokeWidth={2}
                            className="checkmark__check"
                        />
                        <line
                            x1={1}
                            y1={1}
                            x2={50}
                            y2={50}
                            strokeWidth={2}
                            className="checkmark__check"
                        />

                    </svg>}
                </div>
                <div className="toast-txt">
                    <h4 className="toast-title">{props.message}</h4>
                    {/* <span className="toast-des">
                        Your time slots bookes processed by a moderator.
                    </span> */}
                </div>
            </div>
        </div>
    )
};

export default ToastMgs; 